const ReceivableWrapper = () => import('@/pages/chargeManagement/wrapper.vue');
const TuitionTab = () => import('../pages/tuition/tuitionTab');
const TuitionProjectDetails = () => import('../pages/tuition/TuitionProjectDetails');
const TuiConventionGuideMeter = () => import('../pages/tuition/TuiConventionGuideMeter');
const TuiChargeSchedule = () => import('../pages/tuition/TuiChargeSchedule');
const tuiControl = () => import('../pages/tuition/TuiRecChargeControl');
const tuitionVerifyRecord = () => import('../pages/tuition/TuiChangeAuditRecords');
const tuitionTicketManage = () => import('../components/otherTicketManage');
const ImportFileWithExcelAppend = () => import('../pages/tuition/TuiConventionAppend');
const TuiChildCheckList = () => import('../pages/tuition/TuiChildCheckList');
const TuiChildRefund = () => import('../pages/tuition/TuiChildRefund');
const TuiChildRefundRecord = () => import('../pages/tuition/TuiChildRefundRecord');
const TuiGainPaidListDetail = () => import('../pages/tuition/TuiGainPaidListDetail');
const TuiConventionAdd = () => import('../pages/tuition/TuiConventionAdd');
const TuiChildRefundDetail = () => import('../pages/tuition/TuiChildRefundDetail');
const RightPanel = () => import('../components/RightPanel');

export default [
	{ path: '/TuitionHomePage', name: 'TuitionHomePage', component: ReceivableWrapper, meta: { type: 'tuition' } },
	{
		path: '/TuitionTab',
		component: TuitionTab,
		children: [
			{ path: '/', name: 'TuitionProjectDetails', component: TuitionProjectDetails },
			{ path: 'tuitionProgress', name: 'tuitionProgress', component: TuiChargeSchedule },
			{ path: 'tuitionControl', name: 'tuitionControl', component: tuiControl },
			{ path: 'tuitionVerifyRecord', name: 'tuitionVerifyRecord', component: tuitionVerifyRecord },
			{ path: 'tuitionTicketManage', name: 'tuitionTicketManage', component: tuitionTicketManage },
		],
	},
	{ path: '/TuiConventionGuideMeter', name: 'TuiConventionGuideMeter', component: TuiConventionGuideMeter },
	{ path: '/TuiConventionAppend', name: 'TuiConventionAppend', component: ImportFileWithExcelAppend },

	{ path: '/TuiChildCheckList', name: 'TuiChildCheckList', component: TuiChildCheckList },
	{ path: '/TuiChildRefund',
		name: 'TuiChildRefund',
		component: TuiChildRefund,
		children: [
			{
				path: '/TuiChildRightPanel',
				name: 'TuiChildRightPanel',
				component: RightPanel,
				children: [
					{ // 列表右滑框
						path: '/TuiChildRefundDetail/:rowData',
						name: 'TuiChildRefundDetail',
						component: TuiChildRefundDetail,
						meta: { parent: '/TuitionHomePage' },
					},
				],
			},
		] },
	{ path: '/TuiChildRefundRecord',
		name: 'TuiChildRefundRecord',
		component: TuiChildRefundRecord,
		children: [
			{
				path: '/TuiRefundRecordRightPanel',
				name: 'TuiRefundRecordRightPanel',
				meta: { parent: '/ReceivableHomePage' },
				component: RightPanel,
				children: [
					{
						path: '/TuiGainPaidListDetail/:rowData',
						name: 'TuiGainPaidListDetail',
						component: TuiGainPaidListDetail,
						meta: { parent: '/TuitionHomePage' },
					},
				],
			},
		] },

	// { path: '/TuiGainPaidListDetail', name: 'TuiGainPaidListDetail', component: TuiGainPaidListDetail },
	{ path: '/TuiConventionAdd', name: 'TuiConventionAdd', component: TuiConventionAdd },
];
